module.exports = __webpack_public_path__ + "img/3_etablissement_vert.ff8ef639.svg";